<template lang="pug">
tr(
  data-test="cbr-acc-row"
).res-row
  td.checkbox
    v-checkbox(
      hide-details 
      :value="isSelected"
      :key="item.ID" @change="select"
    ).mt-0
  td(data-test="cbr-acc-username").username {{ item.username }}
  transition(name="highlight") 
    td(:key="item.budget").budget {{ item.budget }}
  td(:key="item.slotsLoadingStatus").status
    cbr-acc-import(
      :ID="item.ID"
      :status="cbrAccStatusText"
      :color="cbrAccStatusColor"
      :loading="cbrAccStatusLoading"
    )

  td.course-locations(@click="openLocationChoose")
    span {{ item.courseLocations | renderCities(cities) }}
    template(v-if="item.courseLocations && !item.courseLocations.length") 
      v-btn(x-small outlined).btn-common add 
    
  td.check
    div(@click="openProducts")
      span(v-for="(product, index) in item.products" :key="product") {{ product }}
        template(v-if="item.products.length - 1 !== index") , 
    products-choose(:model="item" :defaultProducts="item.products" @update="updateProducts" ref="products")
  td(@click="openLocationChoose").check 
    checked(:value="item.forReservationSystem")

  transition(name="highlight") 
    td.export(:key="item.slotsExportTime") {{ item.formattedSlotsExportTime }}

  courseLocationProvider(ref="courseLocationModal" :ID="item.ID")
    template(v-slot:default="props")
      courseLocationModal(
        v-model="props.showing"
        @input="hideLocationChoose"
        :processing="props.processing"
        :model="item"
        :hasProducts="hasProducts"
        @submit="props.update"
      )
  
</template>

<script>
import {CBR_ACC_SLOTS_LOADING_STATUS, CBR_ACC_SLOTS_LOADING_STATUS_COLOR} from "../core/cbrAcc-const"
export default {
  props: {
    item: {
      required: true,
      type: Object
    },
    select: Function,
    isSelected: Boolean,
    cities: Array
  },
  data: () => ({
  }),

  mounted() {
  
  },

  computed: {
    cbrAccStatusColor() {
      if(this.item.slotsLoadingStatus === CBR_ACC_SLOTS_LOADING_STATUS.IN_PROGRESS)
        return CBR_ACC_SLOTS_LOADING_STATUS_COLOR.IN_PROGRESS
      if(this.item.slotsLoadingStatus === CBR_ACC_SLOTS_LOADING_STATUS.FAILED)
        return CBR_ACC_SLOTS_LOADING_STATUS_COLOR.FAILED
      return CBR_ACC_SLOTS_LOADING_STATUS_COLOR.INACTIVE
    },

    cbrAccStatusLoading() {
      if(this.item.slotsLoadingStatus === CBR_ACC_SLOTS_LOADING_STATUS.IN_PROGRESS)
        return true
      return false
    },

    cbrAccStatusText() {
      if(this.item.slotsLoadingStatus === CBR_ACC_SLOTS_LOADING_STATUS.INACTIVE) 
        return 'Success'
      return this.item.slotsLoadingStatus
    },

    hasProducts() {
      return this.item.products && this.item.products.length ? true : false
    }
  },

  filters: {
    renderCities(ids, cities) {
      if(!cities) return
      return ids.map(ID => {
        let city = cities.find(city => city.ID === ID)
        if(city) return city.name
      }).join(',')
    }
  },

  methods: {
    openLocationChoose() {
      this.$refs.courseLocationModal.toggle()
    },

    hideLocationChoose(isShowing) {
      if(isShowing) return
      this.$refs.courseLocationModal.toggle()

    },

    openProducts() {
      this.$refs.products.open()
    },

    updateProducts({products}) {
      this.item.products = products
    }
  },
  
  components: {
    cbrAccImport: () => import('./CbrAccImport.vue'),
    courseLocationProvider: () => import('./CbrAccCourseLocationProvider.vue'),
    courseLocationModal: () => import('./cbrAccLocationChoose.vue'),
    productsChoose: () => import('./cbrAccProducts.vue'),

    checked: () => import('@/components/global/CheckBoolean.vue'),
  },
}
</script>

<style lang="scss" scoped>
.res-row {
  transition: background-color .3s;
}
.loaded-not-seen {
  background-color: #ccc;
}
.username {
  text-align: center;
}

.budget {
  text-align: center;
}
.status {
  text-align: center;
    width: 15%;

}
.export {
  text-align: center;
}
.product {
  width: 10%;
  text-align: center;
}
.res-info {
  width: 10%;
  text-align: center;
}
.res-status {
  width: 10%;
  text-align: center;
}
.name {
  min-width: 20%;
  width: 20%;
}

.reserved-students {
  width: 10%;
  text-align: center;
}

.checkbox {
  width: 40px;
}

.course-locations {
  width: 20%;
  text-align: center;
}


</style>

<style lang="scss">
.highlight-enter-active, .highlight-leave-active {
  transition: background 1s ease;
}

.highlight-leave-active {
  display: none;
}
.highlight-enter, .highlight-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  background: #78dfa6;
}

.highlight-leave-to {
  display: none;
}

.check {
  text-align: center;
  width: 100px;
}

</style>
